/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Domestic animal affected
 */
export type CreateReportDtoDomesticAnimalAffected =
  (typeof CreateReportDtoDomesticAnimalAffected)[keyof typeof CreateReportDtoDomesticAnimalAffected];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoDomesticAnimalAffected = {
  yes: 'yes',
  no: 'no',
  dontKnow: 'dontKnow',
} as const;
